const getPropertyByDotNotationIndex = <T,>(entity: T, dotNotationIndex: string): unknown => {
  try {
    const property = dotNotationIndex
      .split('.')
      // @ts-ignore
      .reduce((acc, key) => acc[key as keyof T], entity);
    // @ts-ignore
    return property?.value ? property.value : property;
  } catch (_) {
    return undefined;
  }
};

type PropertyByDotNotationIndexType = <T>(entity: T, dotNotationIndex: string) => unknown;

export const getByDot: PropertyByDotNotationIndexType = getPropertyByDotNotationIndex;

/**
 * This checks an env var injected by Webpack during build time, set to `production` for all deployed environments.
 * To distinguish between our different deployed ENVs, use process.env.REACT_APP_ENVIRONMENT
 */
export const isLocalEnvironment = () => {
  return process.env.NODE_ENV !== 'production';
};
